export const validateAddress = (address, chain) => {
  if (chain === "btc") {
    return /^(bc1|[13])[a-zA-HJ-NP-Z0-9]{25,39}$/.test(address);
  }
  if (chain === "bnb") {
    return /^0x[a-fA-F0-9]{40}$/.test(address);
  }
  if (chain === "trx" || chain === "trx-native") {
    return /^T[a-zA-Z0-9]{33}$/.test(address);
  }
  return false;
};
